import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import Modal from "./Modal";
import { Check, Languages } from "lucide-react";

const LANGUAGES = [
  { value: "en", label: "English" },
  { value: "hi", label: "Hindi" },
  { value: "ur", label: "Urdu" },
  { value: "ar", label: "Arabic" },
  { value: "fr", label: "French" },
  { value: "es", label: "Spanish" },
  { value: "th", label: "Thai" },
  { value: "vi", label: "Vietnamese" },
  { value: "zh", label: "Chinese" },
  { value: "it", label: "Italian" },
];

const LanguageSelector = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { i18n, t } = useTranslation();

  const handleLanguageChange = (language) => {
    i18n.changeLanguage(language);
    document.body.dir = i18n.dir();
    setIsOpen(false);
  };

  return (
    <>
      <button
        className={`absolute top-2 ${document.body.dir === "ltr" ? "right-4" : "left-4"} rounded-full cursor-pointer text-white bg-khamco-ribbon text-3xl transition-all hover:scale-[1.1] hover:bg-khamco-primary outline-none border-2 border-black p-2 z-[1000]`}
        title="Change language"
        onClick={() => setIsOpen(true)}
      >
        <Languages />
      </button>
      <Modal isOpen={isOpen} setIsOpen={() => setIsOpen(false)}>
        <div className="flex flex-col items-center gap-1 mb-6">
          <span className="flex items-center justify-center w-12 h-12 rounded-full bg-khamco-ribbon/10 text-khamco-ribbon">
            <Languages size={24} />
          </span>
          <h2 className="text-center font-minimoBold text-2xl text-khamco-secondary">
            {t("Preferred Language")}
          </h2>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
          {LANGUAGES.map((language) => {
            const isSelected = i18n.resolvedLanguage === language.value;
            return (
              <button
                key={language.value}
                onClick={() => handleLanguageChange(language.value)}
                className={`flex items-center justify-between gap-2 py-2.5 px-4 rounded-xl text-sm font-medium border transition-all cursor-pointer ${
                  isSelected
                    ? "bg-khamco-ribbon text-white border-khamco-ribbon shadow-sm"
                    : "bg-white text-gray-700 border-gray-200 hover:border-khamco-ribbon hover:bg-khamco-ribbon/5"
                }`}
              >
                {t(language.label)}
                {isSelected && <Check size={16} className="shrink-0" />}
              </button>
            );
          })}
        </div>
      </Modal>
    </>
  );
};

export default LanguageSelector;
